import React, { useEffect, useState, useRef } from 'react';
import lodash from 'lodash';
import { useHistory } from 'react-router';

import apiRequest from '../../../utils/api.request';
import config from '../../../config.json';
import { vaccinationApiRequestBody } from '../../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody';
import { parseQueryString } from '../../../utils/utils';
import useTranslation from '../../../hooks/use-translation';
import useLoader from '../../../hooks/use-loader';
import { isJhhIdVerified } from '../Utils/isJhhIdVerified'

import backArrow from '../../../images/back-arrow-white.svg';

import Input from '../../VaccinationDetails/VaccinationDetailsWrapper/Components/InputForm';
import DifferentJhhIdFlow from '../../VaccinationDetails/VaccinationDetailsWrapper/DifferentJhhIdFlow';
import CreateNewJhhIdFlow from '../../VaccinationDetails/VaccinationDetailsWrapper/CreateNewJhhIdFlow';
import ProfileDetails from '../../VaccinationDetails/VaccinationDetailsWrapper/ProfileDetails';

import './JhhIdVerify.css';

const get_profile_details_url = config.covid_vacc_base_url + "v1/get-partner-info/";

let auth_token;
let source_id;
let source_user_id;
let source_relation;
let source_user_relation_id;
let user_name;

const JhhVerifyFlows = {
  CERIFICATE: "certificate",
  SMART_SC: "smart_sc",
  VACCINATION_INFO: "vaccination_info",
  VACCINATION_V2: "vaccination_v2"
}

const VaccinationCertiJhhIdVerify = ({ flow = JhhVerifyFlows.CERIFICATE }) => {
  const { t } = useTranslation();
  const history = useHistory()
  const [sessionError, setSessionError] = useState();
  const [userInfo, setUserInfo] = useState({});
  const [loadUserJourneyError, setLoadUserJourneyError] = useState(false);
  const [showCorporateFlow, _setShowCorporateFlow] = useState(false);
  const [userJourney, setUserJourney] = useState('corporate-jhh-id');
  const { showLoading, hideLoading, loadingCount } = useLoader();

  const user_details = useRef();
  const params = parseQueryString();
  const urlParams = new URLSearchParams(window.location.search);

  const getPartnerInfo = (userParams) => {
    const requestBody = vaccinationApiRequestBody({}, userParams)
    apiRequest(get_profile_details_url, requestBody, true)
      .then(response => {
        hideLoading()
        if (response && response.apiResponse !== "failed") {
          setUserInfo({
            name: lodash.get(response, "name", ""),
            gender: lodash.get(response, "gender", ""),
            date_of_birth: lodash.get(response, "date_of_birth", ""),
            phone: lodash.get(response, "phone", ""),
            jhhID: lodash.get(response, "jhh_id", ""),
            primaryPhone: lodash.get(response, "primary_jhh_info.phone", "")
          });
          if (user_details.current.source_relation !== "Self" && !lodash.get(response, "primary_jhh_info.jhh_id", "")) {
            switch (flow) {
              case JhhVerifyFlows.CERIFICATE:
                setLoadUserJourneyError(t("JHH_ID_NOT_VERIFIED_CERTIFICATE"));
                break;

              case JhhVerifyFlows.SMART_SC:
                setLoadUserJourneyError(t("JHH_ID_NOT_VERIFIED_SC"));
                break;

              case JhhVerifyFlows.VACCINATION_INFO:
                setLoadUserJourneyError(t("JHH_ID_NOT_VERIFIED_VACCINATION_INFO"));
                break;

              case JhhVerifyFlows.VACCINATION_V2:
                setLoadUserJourneyError(t("JHH_ID_NOT_VERIFIED_VACCINATION_INFO"));
                break;

              default:
                setLoadUserJourneyError(t("JHH_ID_NOT_VERIFIED_DEFAULT"));
                break;
            }
          } else {
            setLoadUserJourneyError(false);
            if (lodash.get(response, "jhh_id", "")) {
              _setShowCorporateFlow(true);
            } else {
              _setShowCorporateFlow(false)
            }
          }
        } else {
          setLoadUserJourneyError(lodash.get(response, "response.data.message", "Something went wrong, please try again"));
        }
      })
  }

  const callbackAfterOtpVerify = () => {
    switch (flow) {
      case JhhVerifyFlows.CERIFICATE:
        history.replace(`/vaccination-certificate/cowin?${urlParams.toString()}`);
        break;

      case JhhVerifyFlows.SMART_SC:
        history.replace(`/vaccination-sc?${urlParams.toString()}&get_jhhid_info=false`);
        break;

      case JhhVerifyFlows.VACCINATION_INFO:
        history.replace(`/vaccination-details?${urlParams.toString()}&get_jhhid_info=false`);
        break;

      case JhhVerifyFlows.VACCINATION_V2:
        // history.replace(`/my-vaccinations/dose-1?${urlParams.toString()}&get_jhhid_info=false`);
        break;

      default:
        history.replace(`/vaccination-certificate/cowin?${urlParams.toString()}`);
        break;
    }
  }

  const UserJourney = () => {
    switch (userJourney) {
      case 'corporate-jhh-id':
        return <ProfileDetails showCorporateFlow={showCorporateFlow} userInfo={userInfo} profileDetails={user_details.current} handleUserJourneyChange={handleUserJourneyChange} t={t} callbackAfterOtpVerify={callbackAfterOtpVerify} closeWindowOnThankYouDone={flow === JhhVerifyFlows.VACCINATION_V2} />;
      case 'different-jhh-id':
        return <DifferentJhhIdFlow showCorporateFlow={showCorporateFlow} handleUserJourneyChange={handleUserJourneyChange} profileDetails={user_details.current} userName={user_name} t={t} callbackAfterOtpVerify={callbackAfterOtpVerify} closeWindowOnThankYouDone={flow === JhhVerifyFlows.VACCINATION_V2} />;
      case 'create-new-jhh-id':
        return <CreateNewJhhIdFlow showCorporateFlow={showCorporateFlow} handleUserJourneyChange={handleUserJourneyChange} userInfoFromApi={userInfo} profileDetails={user_details.current} t={t} callbackAfterOtpVerify={callbackAfterOtpVerify} closeWindowOnThankYouDone={flow === JhhVerifyFlows.VACCINATION_V2} />;
    }
  }

  const handleUserJourneyChange = (userJourney) => {
    setUserJourney(userJourney)
  }

  useEffect(() => {
    auth_token = lodash.get(params, "auth_token");
    source_id = lodash.get(params, "source_id");
    source_user_id = lodash.get(params, "source_user_id");
    source_relation = lodash.get(params, "source_relation");
    source_user_relation_id = lodash.get(params, "source_user_relation_id");
    user_name = lodash.get(params, "t");
    if (!auth_token || !source_id || !source_user_id || !source_relation || (source_user_relation_id == undefined) || !user_name) {
      setSessionError("Session expired, please login again");
    }
    else {
      user_name = atob(user_name);
      user_details.current = {
        auth_token,
        source_id,
        source_user_id,
        source_relation,
        source_user_relation_id
      };
      showLoading()
      isJhhIdVerified(user_details.current)
        .then(response => {
          if (String(lodash.get(response, "validated")).toLowerCase() == "yes") {
            hideLoading()
            switch (flow) {
              case JhhVerifyFlows.CERIFICATE:
                history.replace(`/vaccination-certificate/cowin?${urlParams.toString()}`)
                break;

              case JhhVerifyFlows.SMART_SC:
                history.replace(`/vaccination-sc?${urlParams.toString()}&get_jhhid_info=false`)
                break;

              case JhhVerifyFlows.VACCINATION_INFO:
                history.replace(`/vaccination-details?${urlParams.toString()}&get_jhhid_info=false`)
                break;

              case JhhVerifyFlows.VACCINATION_V2:
                history.replace(`/my-vaccinations/dose-1?${urlParams.toString()}&get_jhhid_info=false`)
                break;

              default:
                history.replace(`/vaccination-certificate/cowin?${urlParams.toString()}`)
                break;
            }
          }
          else {
            getPartnerInfo(user_details.current);
          }
        })
        .catch(error => {
          hideLoading()
          setSessionError(error.message || "Session expired, please login again")
        })
    }
  }, [])

  if (sessionError) {
    return (
      <div className="paddingLarge verify-jhh-id-error">
        <p className="font-color-red">{sessionError}</p>
      </div>
    )
  }

  if (loadingCount) {
    return (
      <div></div>
    )
  }

  const _getHeaderFromFLow = () => {
    switch (flow) {
      case JhhVerifyFlows.CERIFICATE:
        return "COWIN_CERT_UPLOAD_HEADER";

      case JhhVerifyFlows.SMART_SC:
        return "VALIDATE_JIOHEALTHHUB_ID"

      case JhhVerifyFlows.VACCINATION_INFO:
        return "VALIDATE_JIOHEALTHHUB_ID"

      case JhhVerifyFlows.VACCINATION_V2:
        return "VALIDATE_JIOHEALTHHUB_ID"

      default:
        return "COWIN_CERT_UPLOAD_HEADER"
    }
  }

  return (
    <div className="paddingLarge verify-jhh-id express-interest-width-wrapper">
      <div className="person-name">
        <img className="back-arrow express-interest-back-arrow" onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} src={backArrow} alt="arrow back"></img>
        <div className="express-interest-header-text">{t(_getHeaderFromFLow())}</div>
      </div>
      {loadUserJourneyError ?
        <div>
          <br />
          {<p className="form-element-error load-user-journey-error load-user-journey-error-certificate" dangerouslySetInnerHTML={{ __html: loadUserJourneyError }}></p>}
          <br />
          <Input
            type="button"
            addClassInput="express-interest-modal-button-yes express-interest-close-button"
            value={t("EOI_DONE")}
            onClick={() => window.close()} />
        </div>
        :
        <UserJourney />
      }
    </div>
  )

}

export default VaccinationCertiJhhIdVerify;